interface VideoIconProps {
  className?: string;
}

export function VideoIcon({ className }: VideoIconProps) {
  return (
    <svg
      width="19.6"
      height="19.6"
      viewBox="0 0 19.6 19.6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_video)">
        <path
          d="M14.0968 7.31319V4.90043C14.0968 4.38061 13.8903 3.88207 13.5227 3.5145C13.1551 3.14693 12.6566 2.94043 12.1368 2.94043H2.94047C2.42064 2.94043 1.92211 3.14693 1.55454 3.5145C1.18697 3.88207 0.980469 4.38061 0.980469 4.90043V14.7004C0.980469 15.2203 1.18697 15.7188 1.55454 16.0864C1.92211 16.4539 2.42064 16.6604 2.94047 16.6604H12.1368C12.6566 16.6604 13.1551 16.4539 13.5227 16.0864C13.8903 15.7188 14.0968 15.2203 14.0968 14.7004V12.2877L17.1799 13.9321C17.3291 14.0116 17.4965 14.0511 17.6655 14.0468C17.8346 14.0425 17.9997 13.9945 18.1447 13.9074C18.2897 13.8204 18.4097 13.6974 18.4931 13.5502C18.5765 13.4031 18.6204 13.2369 18.6205 13.0677V6.53311C18.6204 6.36399 18.5765 6.19777 18.4931 6.05063C18.4097 5.90349 18.2897 5.78043 18.1447 5.69342C17.9997 5.60641 17.8346 5.55841 17.6655 5.55408C17.4965 5.54976 17.3291 5.58926 17.1799 5.66875L14.0968 7.31319Z"
          stroke="#A8B4BD"
          strokeWidth="1.995"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_video">
          <rect width="19.6" height="19.6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
